import { render } from "./QueryGrid_sub.vue?vue&type=template&id=6af7e1a9"
import script from "./QueryGrid_sub.vue?vue&type=script&lang=js"
export * from "./QueryGrid_sub.vue?vue&type=script&lang=js"

import "./QueryGrid_sub.vue?vue&type=style&index=0&id=6af7e1a9&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__